<script setup>
import {ref} from "vue";
import InputError from "@/Components/InputError.vue";
const props = defineProps({
    modelValue: [String,Number],
    error: String,
    data: [Array, Object]
})

const emit = defineEmits(['update:modelValue'])

const createNew = ref(false)
</script>
<template>
    <div class="block w-full">
        <label
            for="group_id"
            class="block text-sm font-medium text-gray-700"
        >Group Id</label
        >
        <select
            v-if="!createNew"
            :value="modelValue"
            @input="emit('update:modelValue',$event.target.value)"
            id="group_id"
            name="group_id"
            autocomplete="off"
            class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
        >
            <option value="">Select Group Id</option>
            <option v-for="id in data" :key="id" :value="id">
                {{ id }}
            </option>
        </select>
        <input
            v-else
            :value="modelValue"
            @input="emit('update:modelValue',$event.target.value)"
            type="number"
            name="group_id"
            id="group_id"
            placeholder="Create a new group id"
            class="mt-1
                   focus:ring-indigo-500 focus:border-indigo-500
                   block
                   w-full
                   shadow-sm
                   sm:text-sm
                   border-gray-300
                   rounded-md"
        />
        <button @click="createNew = !createNew" class="text-gray-600" title="Create a new group id">
            <svg v-if="!createNew" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
            </svg>
        </button>
        <InputError
            v-if="error"
            :message="error"
        />
    </div>
</template>
